/**
 * The parameters a service asks for (services spec 10), as Add extra draws
 * them: an option chosen from a list ("Choose…"), or a whole number typed in,
 * "(optional)" beside one that isn't required. Shared by Classic's
 * `AddExtraDialog` and One's parameters widget, which each hold the values and
 * the errors; the rules are shared-core's `service-parameters`.
 */
import type { ServiceParameterForm } from "@shared-core/domain/service-parameters";
import { Input } from "../../primitives/input";
import { Field } from "./OrderDialogs";

export function ServiceParameterFields({
  idPrefix,
  parameters,
  values,
  errorOf,
  onChange,
  disabled = false,
}: {
  idPrefix: string;
  /** The parameters asked for now (those the ticked activities ask for). */
  parameters: readonly ServiceParameterForm[];
  /** Each parameter's value as typed or chosen, by key. */
  values: Readonly<Record<string, string>>;
  errorOf: (key: string) => string | undefined;
  onChange: (key: string, value: string, isTyping: boolean) => void;
  disabled?: boolean;
}) {
  return (
    <>
      {parameters.map((p) => (
        <Field
          key={p.key}
          id={`${idPrefix}-parameter-${p.key}`}
          label={p.required ? p.label : `${p.label} (optional)`}
          error={errorOf(p.key)}
        >
          {(aria) =>
            p.value_type === "option" ? (
              <select
                {...aria}
                value={values[p.key] ?? ""}
                disabled={disabled}
                onChange={(e) => onChange(p.key, e.target.value, false)}
                className="h-9 w-full rounded-md border border-border bg-card px-3 text-sm"
              >
                <option value="">Choose…</option>
                {p.options.map((o) => (
                  <option key={o.code} value={o.code}>
                    {o.label}
                  </option>
                ))}
              </select>
            ) : (
              <Input
                {...aria}
                inputMode="numeric"
                value={values[p.key] ?? ""}
                disabled={disabled}
                onChange={(e) => onChange(p.key, e.target.value, true)}
              />
            )
          }
        </Field>
      ))}
    </>
  );
}
